import ShareSocialDialogButton from '../SocialShare/ShareSocialDialogButton'
import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'
import { getSchoolActiveDomainName } from '../../services/utils'
import { IQuiz } from '../../interfaces/IQuiz'

export default function ShareQuizButton(props: {
  school: ISchool
  quiz: IQuiz
  buttonStyle?: React.CSSProperties
  buttonSize?: 'small' | 'medium'
}) {
  const { school } = props
  const [quizUrl] = React.useState(
    `https://${getSchoolActiveDomainName(school)}/quiz?quizId=${
      props.quiz?.slug || props.quiz?._id
    }`,
  )

  return (
    <ShareSocialDialogButton
      buttonSize={props.buttonSize}
      label={'Share this link with students for them to access this quiz'}
      url={quizUrl}
      title={`Attempt quiz ${props.quiz.name}`}
      buttonStyle={props.buttonStyle}
    />
  )
}
